import SessionExpiringSoonModal from './SessionExpiringSoonModal';

export default SessionExpiringSoonModal;
